<template>
    <div class="seller-widget" @keydown.esc="zoomPhoto({})" tabindex="0">
        <div class="h3 progress-steps">
            <div v-if="!init && currentStep < 5" class="d-flex flex-row align-items-center">
                <div v-for="(step, index) in steps" :key="step.text" class="d-flex align-items-center me-md-3">
                    <div :class="'item-circle me-1' + stepClass(index + 1, currentStep)">
                        <span v-if="currentStep-1 < index+1">{{ index+1 }}</span>
                        <i v-else class="fa fa-check fa-sm"></i>
                    </div>
                    <div class="w-auto">
                        <svg class="w-100" :viewBox="calcViewBox(step.text)">
                            <text x="0" y="15">{{step.text}}</text>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="currentStep === 1">
            <h4 class="text-center my-4">Lets get started! Sign in to your account or register to create a new one.</h4>
            <sign-in-register auto-reload="true"></sign-in-register>
        </div>
        <div v-if="!init && currentStep === 2">
            <h4>{{ title }}</h4>
            <div>
                <h4 class="my-4">Tell us about your vehicle</h4>
                <h5>Welcome!  We need a few pieces of information to get your listing live and in front of potential buyers</h5>
                <div class="vehica-inventory-v1">
                    <div class="row">
                        <div class="col-sm-12 mb-4">
                            <div :class="'vehica-text-field' + (form.vin ? ' vehica-active vehica-active-number' : '')">
                                <input type="text"
                                       placeholder="VIN# *"
                                       name="vin"
                                       v-model="form.vin"
                                       @change="vinChanged"
                                       onfocus="this.select()"
                                       autocomplete="off"
                                       autofocus>
                                <label class="vehica-results__field__label">VIN# *</label>
                                <div v-if="errors.vin" class="vehica-field--validation-required__tip">
                                    <div class="vehica-field--validation-required__tip__text">
                                        {{ errors.vin }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 mb-4">
                            <div :class="'vehica-text-field' + (form.year ? ' vehica-active vehica-active-number' : '')">
                                <input placeholder="Year *"
                                       type="text"
                                       name="year"
                                       v-model="form.year"
                                       maxlength="4"
                                       inputmode="numeric"
                                       @keypress="numberOnly"
                                       onfocus="this.select()"
                                       autocomplete="off">
                                <label class="vehica-results__field__label">Year *</label>
                                <div v-if="errors.year" class="vehica-field--validation-required__tip">
                                    <div class="vehica-field--validation-required__tip__text">
                                        {{ errors.year }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 mb-4">
                            <div :class="'vehica-text-field' + (form.mileage ? ' vehica-active vehica-active-number' : '')">
                                <input placeholder="Mileage *"
                                       type="text"
                                       name="mileage"
                                       v-mask="{mask:Number,thousandsSeparator:','}"
                                       v-model="form.mileage"
                                       inputmode="numeric"
                                       @keypress="numberOnly"
                                       onfocus="this.select()"
                                       autocomplete="off">
                                <label class="vehica-results__field__label">Mileage *</label>
                                <div v-if="errors.mileage" class="vehica-field--validation-required__tip">
                                    <div class="vehica-field--validation-required__tip__text">
                                        {{ errors.mileage }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 mb-2">
                            <div class="vehica-results__fields pb-1">
                                <vehicle-make class="vehica-results__field vehica-relation-field vehica-results__field--relation_show w-100 p-0"
                                              :make="form.make"
                                               required="required"
                                              @input="toggleMake"></vehicle-make>
                                <div v-if="errors.make" class="vehica-field--validation-required__tip">
                                    <div class="vehica-field--validation-required__tip__text">
                                        {{ errors.make }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 mb-2">
                            <div class="vehica-results__fields pb-1">
                                <vehicle-model class="vehica-results__field vehica-relation-field vehica-results__field--relation_show w-100 p-0"
                                               :list="models"
                                               :value="form.model"
                                               required="required"
                                               @input="toggleModel"></vehicle-model>
                                <div v-if="errors.model" class="vehica-field--validation-required__tip">
                                    <div class="vehica-field--validation-required__tip__text">
                                        {{ errors.model }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 mb-2">
                            <div class="vehica-results__fields pb-1">
                                <color-picker class="vehica-results__field vehica-relation-field vehica-results__field--relation_show w-100 p-0"
                                              :color="form.exterior"
                                              label="Exterior Color *"
                                              @input="setExteriorColor"></color-picker>
                                <div v-if="errors.exterior" class="vehica-field--validation-required__tip">
                                    <div class="vehica-field--validation-required__tip__text">
                                        {{ errors.exterior }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--<div class="col-md-6 mb-2">
                            <div class="vehica-results__fields pb-1">
                                <color-picker class="vehica-results__field vehica-relation-field vehica-results__field--relation_show w-100 p-0"
                                              :color="form.interior"
                                              label="Interior Color"
                                              @input="setInteriorColor"></color-picker>
                            </div>
                        </div>-->
                        <!--</div>

                        <div class="row">-->
                        <div class="col-md-6 mb-4">
                            <div :class="'vehica-text-field' + (form.zip ? ' vehica-active vehica-active-number' : '')">
                                <input placeholder="Zip code *"
                                       type="text"
                                       name="zip"
                                       v-model="form.zip"
                                       maxlength="6"
                                       inputmode="numeric"
                                       @keypress="numberOnly"
                                       onfocus="this.select()"
                                       autocomplete="off">
                                <label class="vehica-results__field__label">Zip code *</label>
                                <div v-if="errors.zip" class="vehica-field--validation-required__tip">
                                    <div class="vehica-field--validation-required__tip__text">
                                        {{ errors.zip }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--
                        <div class="col-md-6 mb-4">
                            <div :class="'vehica-text-field' + (form.price ? ' vehica-active vehica-active-number' : '')">
                                <input placeholder="Sell price"
                                       type="text"
                                       name="price"
                                       v-mask="currencyMask"
                                       v-model="form.price"
                                       inputmode="numeric"
                                       @keypress="numberOnly"
                                       onfocus="this.select()"
                                       autocomplete="off">
                                <label class="vehica-results__field__label">Sell price</label>
                                <div v-if="errors.price" class="vehica-field--validation-required__tip">
                                    <div class="vehica-field--validation-required__tip__text">
                                        {{ errors.price }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        -->
                    </div>
                </div>
            </div>
        </div>

        <div v-if="currentStep === 3" class="position-relative">
            <h4 class="my-4">Add photos of your vehicle</h4>

            <div class="photo-upload-grid mb-4">
                <div v-for="(photo, index) in form.medias" :key="index" class="photo-upload">
                    <div class="btn photo-image" tabindex="0"
                         :style="photoStyles(photo)"
                         @click.prevent="zoomPhoto(photo)">
                        <i class="fa fa-2x fa-camera text-primary" v-if="photo.angle && !photo.id"></i>
                        <i class="fa fa-3x fa-play-circle text-white-50" v-if="photo.video"></i>
                    </div>
                    <div v-if="photo.loading" class="loading-indicator"><i class="fa fa-3x fa-spinner fa-spin"></i></div>
                </div>
                <div class="btn-group-vertical photo-upload photo-upload-add my-1">
                    <button class="btn btn-outline-primary d-flex align-items-center w-100"
                            :style="hasVideo ? 'max-height:50%' : ''"
                            @click.prevent="addPhoto({})">
                        <i class="fa fa-2x fa-camera flex-grow-1"></i><span class="elementor-hidden-phone flex-grow-1">Add Photo</span>
                    </button>
                    <button class="btn btn-outline-primary d-flex align-items-center w-100"
                            style="max-height:50%"
                            v-if="!hasVideo"
                            @click.prevent="addVideo()">
                        <i class="fa fa-2x fa-video flex-grow-1"></i><span class="elementor-hidden-phone flex-grow-1">Add Video</span>
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <h4 class="text-center"> OR </h4>
                    <label class="btn btn-outline-primary mb-4 w-100" for="uploadAll">
                        Upload all of your photos at once
                        <input type="file" multiple accept="image/*" @change="onSelectedFiles" style="display:none" id="uploadAll" name="uploadAll" />
                    </label>
                </div>
            </div>
            <div v-if="photoDetail.id" class="photo-detail px-3">
                <div class="image">
                    <video v-if="photoDetail.video" class="img-fluid" :src="photoDetail.video" controls disablePictureInPicture controlslist="nodownload noplaybackrate"></video>
                    <img v-else :src="photoDetail.url" class="img-fluid" @click.stop="zoomPhoto({})" />
                    <button class="btn btn-close btn-close-white" title="Close" @click.stop="zoomPhoto({})"></button>
                    <div class="photo-controls">
                        <div class="row">
                            <div class="col text-end">
                                <button class="btn text-danger bg-light" title="Remove photo" @click.stop="removePhoto(photoDetail)"><i class="fa fa-trash"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="currentStep === 4" class="mb-4">
            <div class="d-flex">
                <h4>
                    Terms of Service
                </h4>
                <div class="flex-fill">
                    <a class="btn btn-sm text-primary float-end" href="/print?terms-of-service.html" target="_blank">
                        <i class="fa fa-print"></i> Print
                    </a>
                </div>
            </div>
            <div class="agreement-terms-container">
                <div class="agreement-terms" v-html="termsOfService"></div>
            </div>
            <check-box id="terms" class="agreement-checkbox" v-model="form.terms">I agree to the terms of Service</check-box>
            <div v-if="errors.terms" class="vehica-field--validation-required__tip">
                <div class="vehica-field--validation-required__tip__text">
                    {{ errors.terms }}
                </div>
            </div>
        </div>

        <div v-if="currentStep >= 5" class="mb-4">
            <div class="d-flex flex-column">
                <div class="row">
                    <div class="col-12">
                        <h3>Sell Your Ride - Current Status</h3>
                    </div>
                    <div class="col-md-3">
                        <img style="border-radius: 4px" :src="getThumbnail()" />
                    </div>
                    <div class="col-md-9">
                        <div class="h5">
                            {{form.year}} {{form.make}} {{form.model}}
                        </div>
                        <div class="h6">
                            {{ numberFormat(form.mileage) }} miles<br />
                            {{ form.vin }}<br />
                            {{ form.zip }}
                        </div>
                    </div>
                </div>
                <h5 class="alert alert-success my-3">
                    We are reviewing your vehicle details and will contact you soon.
                </h5>
            </div>
            <div class="h4 progress-steps ms-3">
                <div v-for="(step, index) in progress" :key="step.text" class="d-flex align-items-center mb-3">
                    <div :class="'item-circle me-1' + stepClass(index, currentStep - 4)">
                        <span v-if="currentStep-4 < index+1">{{ index+1 }}</span>
                        <i v-else class="fa fa-check fa-sm"></i>
                    </div>
                    <div class="w-auto">
                        {{step.text}}
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!init && values.authenticated && currentStep < 5" class="row">
            <div class="col-6 mb-4">
                <submit-button v-if="backEnabled"
                               class-name="btn-light w-100"
                               :disabled="loading"
                               @click="back">
                    Go back
                </submit-button>
            </div>
            <div class="col-6 mb-4">
                <submit-button class-name="w-100"
                               :active="loading"
                               @click="next">
                    Continue
                </submit-button>
            </div>
        </div>

        <interactive-camera v-if="showCamera" @input="newPhoto" @cancel="showCamera=false" :text="cameraAngleText" :overlay="cameraAngleOverlay"></interactive-camera>

        <upload-video-dialog ref="videoDialog"
                             @submit="uploadVideo"
                             @cancel="cancelUploadVideo"
                             :error="uploadVideoError"
                             :progress="uploadVideoProgress"
                             :loading="uploadVideoProgress != null"></upload-video-dialog>
    </div>
</template>
<script>
    import axios from 'axios';
    import CheckBox from '../common/fields/CheckBox';
    import ColorPicker from '../common/fields/ColorPicker';
    import { IMaskDirective } from 'vue-imask';
    import InteractiveCamera from '../components/camera/InteractiveCamera';
    import Messages from '../common/Messages';
    import SignInRegister from '../components/signin/SignInRegister';
    import SubmitButton from '../common/fields/SubmitButton';
    import UploadVideoDialog from '../dialog/UploadVideoDialog';
    import VehicleMake from '../common/fields/VehicleMake';
    import VehicleModel from '../common/fields/VehicleModel';

    const cameraAngles = [{}, //0 is nothing
        { text: 'Take a direct front view picture', overlay: '/img/overlays/1.svg' },
        { text: 'Take a picture of the left side', overlay: '/img/overlays/2.svg' },
        { text: 'Take a picture of the right side', overlay: '/img/overlays/3.svg' },
        { text: 'Take a direct rear view picture', overlay: '/img/overlays/4.svg' },
        { text: 'Take a picture of the dashboard with the car ON', overlay: '/img/overlays/5.svg' },
    ];

    const canvas = document.createElement('canvas');
    const fontContext = canvas.getContext('2d');
    var abortController = null;

    export default {
        props: ['values'],
        components: {
            CheckBox,
            ColorPicker,
            InteractiveCamera,
            SignInRegister,
            SubmitButton,
            UploadVideoDialog,
            VehicleMake,
            VehicleModel,
        },
        directives: {
            mask: IMaskDirective
        },
        data: function () {
            return {
                cameraAngle: 0,
                errors: {},
                init: true,
                loading: false,
                form: {
                    id: null,
                    vin: '',
                    year: '',
                    mileage: '',
                    make: '',
                    model: '',
                    exterior: '',
                    interior: '',
                    zip: '',
                    price: '',
                    terms: false,
                    medias: [],
                },
                models: [],
                photoDetail: {},
                currentStep: 1,
                steps: [
                    { text: 'Sign in' },
                    { text: 'Details' },
                    { text: 'Photos' },
                    { text: 'Terms' },
                ],
                progress: [
                    { text: 'Vehicle details received' },
                    { text: 'Vehicle is getting listed' },
                    { text: 'Listing is live' },
                    { text: 'Negotiating' },
                    { text: 'Offer received and agreed upon' },
                    { text: 'Paperwork complete' },
                    { text: 'Payment processed' },
                ],
                showCamera: false,
                termsOfService: null,
                title: '',
                uploadVideoError: '',
                uploadVideoProgress: null,
            };
        },
        computed: {
            backEnabled() {
                return this.currentStep > 2;
            },
            cameraAngleText() {
                return cameraAngles[this.cameraAngle]?.text;
            },
            cameraAngleOverlay() {
                return cameraAngles[this.cameraAngle]?.overlay;
            },
            currencyMask() {
                return {
                    mask: '$num',
                    blocks: {
                        num: {
                            mask: Number,
                            scale: 0,
                            signed: false,
                            thousandsSeparator: ',',
                            padFractionalZeros: false,
                            normalizeZeros: false,
                            radix: '.',
                            min: 0,
                            //max: 9999999
                        }
                    }
                };
            },
            hasVideo() {
                return !!this.form.medias.find(p => p.video);
            }
        },
        methods: {
            addMissingPhotos() {
                const vm = this;
                cameraAngles.forEach((a, i) => {
                    if (i && !vm.form.medias.find(p => p.angle === i)) {
                        vm.form.medias.push({ url: '', overlay: a.overlay, angle: i, loading: false });
                    }
                });
                vm.form.medias.sort((a, b) => {
                    if (a.angle && b.angle) {
                        return a.angle > b.angle ? 1 : a.angle === b.angle ? 0 : -1;
                    }
                    return a.angle ? 1 : b.angle ? -1 : 0;
                })
            },
            addPhoto(options) {
                this.cameraAngle = options?.angle ?? 0;
                this.showCamera = true;
            },
            addVideo() {
                this.$refs.videoDialog.show();
            },
            back() {
                this.currentStep--;
            },
            calcViewBox(text) {
                fontContext.font = '24px "Muli, Arial, Helvetica, sans-serif"';
                const px = fontContext.measureText(text).width;
                return '0 0 ' + px + ' 20';
            },
            getStatus() {
                const vm = this;
                vm.loading = true;
                axios.get('/sell/status')
                    .then(r => {
                        if (r.data.form.id) {
                            vm.form = r.data.form;
                            vm.currentStep = r.data.currentStep;
                        }
                        vm.addMissingPhotos();
                    })
                    .catch(e => {
                        Messages.error({ html: e.data?.message || e.message });
                    })
                    .finally(() => {
                        vm.loading = false;
                        vm.init = false;
                    });
            },
            getThumbnail() {
                if (this.form?.medias?.length) {
                    return this.form?.medias.find(m => !m.video).url;
                }
                return 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
            },
            next() {
                if (this.currentStep === 2) {
                    this.submitDetails();
                } else if (this.currentStep === 3) {
                    this.submitPhotos();
                } else if (this.currentStep === 4) {
                    this.submitSignature();
                }
            },
            newPhoto(bits, url) {
                const vm = this;
                vm.showCamera = false;
                const file = new File([bits], 'photo.png', {
                    type: 'image/png'
                });
                const angle = vm.cameraAngle
                const photo = angle ? vm.form.medias.find(p => p.angle === angle) : {};
                photo.loading = true;
                photo.url = url;
                vm.uploadPhoto(file, photo)
                    .then(r => {
                        if (r.data.error) {
                            Messages.warning({ html: e.data?.error });
                        } else {
                            photo.url = r.data.url;
                            photo.id = r.data.id;
                            photo.loading = false;
                        }
                    })
                    .catch(e => {
                        Messages.error({ html: e.data?.message || e.message });
                    })
                    .finally(() => {
                        vm.loading = false;
                    });
            },
            numberFormat(num, digits) {
                return (1*num).toLocaleString('en-US', { minimumFractionDigits: digits ?? 0 })
            },
            numberOnly(event) {
                if (!event.keyCode || event.keyCode < 48 || event.keyCode > 57) {
                    event.preventDefault();
                }
            },
            async onSelectedFiles(event) {
                const vm = this;
                let input = event.target;
                let files = input.files;

                let i = 0;
                while (i < files.length) {
                    let file = files[i];
                    if (file.type.startsWith('image/')) {
                        let photo = vm.form.medias.find(p => p.angle && (!p.url || p.url == p.overlay)) ?? {};
                        photo.loading = true;
                        let r = await vm.uploadPhoto(file, photo);
                        if (r.data.error) {
                            input.value = '';
                            Messages.warning({ html: e.data?.error });
                            return;
                        } else {
                            photo.url = r.data.url;
                            photo.id = r.data.id;
                            photo.loading = false;
                        }
                    } else {
                        //ignore other file types
                    }
                    i++;
                }
                vm.loading = false;
                input.value = '';
            },
            photoStyles(photo) {
                if (photo.url)
                    return { 'background-image': 'url(' + photo.url + ')' };
                if (photo.angle)
                    return { 'background-image': 'url(' + photo.overlay + ')' };
            },
            removePhoto(photo) {
                const vm = this;
                axios.delete('/sell/' + vm.form.id + '/removephoto/' + photo.id)
                    .then(r => {
                        let i = vm.form.medias.indexOf(photo);
                        if (i >= 0) {
                            if (!photo.angle) {
                                vm.form.medias.splice(i, 1);
                            } else {
                                photo.url = cameraAngles[photo.angle]?.overlay;
                                photo.id = null;
                            }
                            vm.zoomPhoto({});
                        }
                    })
                    .catch(e => {
                        Messages.error({ html: e.data?.message || e.message });
                    });
            },
            setExteriorColor(value) {
                this.form.exterior = value;
            },
            setInteriorColor(value) {
                this.form.interior = value;
            },
            stepClass(step, current) {
                if (step > current) return ' o-66';
                if (step < current) return ' bg-success';
                return '';
            },
            submitDetails() {
                const vm = this;
                vm.loading = true;
                let data = {
                    id: vm.form.id,
                    vin: vm.form.vin,
                    year: '' + vm.form.year,
                    mileage: vm.form.mileage?.replaceAll(',', ''),
                    make: vm.form.make,
                    model: vm.form.model,
                    exterior: vm.form.exterior,
                    interior: vm.form.interior,
                    zip: vm.form.zip,
                    price: vm.form.price,
                };
                axios.post('/sell/submit', data)
                    .then(r => {
                        vm.errors = r.data.errors;
                        if (r.data.message) {
                            if (r.data.success) {
                                Messages.success({ html: r.data.message })
                                    .then(() => {
                                        if (vm.currentStep > 4) {
                                            window.location.reload();
                                        }
                                    });
                            } else {
                                Messages.warning({ html: r.data.message });
                            }
                        }
                        if (r.data.success) {
                            vm.form.id = r.data.id;
                            vm.currentStep++;
                        }
                    })
                    .catch(e => {
                        Messages.error({ html: e.data?.message || e.message });
                    })
                    .finally(() => {
                        vm.loading = false;
                    });
            },
            submitPhotos() {
                const vm = this;
                vm.loading = true;
                axios.post('/sell/submitphotos/' + vm.form.id)
                    .then(r => {
                        vm.errors = r.data.errors;
                        if (r.data.message) {
                            if (r.data.success)
                                Messages.success({ html: r.data.message });
                            else
                                Messages.warning({ html: r.data.message });
                        }
                        if (r.data.success) {
                            vm.currentStep++;
                        }
                    })
                    .catch(e => {
                        Messages.error({ html: e.data?.message || e.message });
                    })
                    .finally(() => {
                        vm.loading = false;
                    });
            },
            submitSignature() {
                const vm = this;
                if (!vm.form.terms) {
                    vm.errors.terms = 'You must agree to the terms to continue';
                    return;
                }
                vm.errors.terms = null;
                vm.loading = true;
                axios.post('/sell/sign/' + vm.form.id)
                    .then(r => {
                        vm.errors = r.data.errors;
                        if (r.data.message) {
                            if (r.data.success)
                                Messages.success({ html: r.data.message });
                            else
                                Messages.warning({ html: r.data.message });
                        }
                        if (r.data.success) {
                            vm.currentStep++;
                        }
                    })
                    .catch(e => {
                        Messages.error({ html: e.data?.message || e.message });
                    })
                    .finally(() => {
                        vm.loading = false;
                    });
            },
            toggleMake(option) {
                if (option.length) {
                    this.form.make = option[0].id;
                    this.models = option[0].models ?? [];
                } else {
                    this.models = [];
                    this.form.make = null;
                }
                const value = this.form.model;
                if (!this.models.find(m => m.id == value)) {
                    this.form.model = null;
                }
            },
            toggleModel(option) {
                if (option?.length)
                    this.form.model = option[0].id;
            },
            uploadPhoto(file, photo) {
                const vm = this;
                const formdata = new FormData();
                formdata.set('id', vm.form.id);
                formdata.set('angle', photo.angle);
                formdata.append('photo', file);
                if (!photo.angle) {
                    vm.form.medias.push(photo);
                }
                vm.loading = true;
                return axios.post('/sell/photo', formdata, { headers: { 'Content-Type': 'multipart/form-data' } });
            },
            uploadVideo(file) {
                const vm = this;
                const data = new FormData();
                data.set('file', file);
                data.set('id', vm.form.id);
                abortController = new AbortController();
                const config = {
                    headers: { 'Content-Type': 'multipart/form-data' },
                    signal: abortController.signal,
                    onUploadProgress: function (progressEvent) {
                        vm.uploadVideoProgress = (progressEvent.loaded * 100) / progressEvent.total;
                    }
                };
                vm.uploadVideoProgress = 0;
                axios.post('/sell/video', data, config)
                    .then(
                        r => {
                            if (r.status === 200) {
                                if (!r.data || r.data.error) {
                                    Messages.warning({ html: r.data?.error || 'Upload failed!' });
                                    vm.uploadVideoError = r.data?.error || 'Upload failed!';
                                } else {
                                    vm.form.medias.push(r.data);
                                    vm.$refs.videoDialog.hide();
                                }
                            } else {
                                vm.uploadVideoError = r.data?.message;
                            }
                        },
                        err => {
                            if (!axios.isCancel(err)) {
                                console.log(err);
                                vm.uploadVideoError = err.response?.data?.message || err.message;
                            }
                        }
                    )
                    .catch(err => {
                        if (!axios.isCancel(err)) {
                            console.log(err);
                            vm.uploadVideoError = err.message;
                        }
                    })
                    .finally(() => {
                        vm.uploadVideoProgress = null;
                    });
            },
            cancelUploadVideo() {
                abortController?.abort();
            },
            vinChanged() {
                const vm = this;
                const vin = vm.form.vin.trim();
                axios.post('/sell/validatevin', { vin })
                    .then(r => {
                        if (r.data) { // && r.data.valid) {
                            if (r.data.year) vm.form.year = r.data.year;
                            if (r.data.make) vm.form.make = r.data.make;
                        }
                    });
            },
            zoomPhoto(photo) {
                if (photo.angle && !photo.id) { //specific angle photo
                    this.addPhoto(photo);
                } else {
                    this.photoDetail = photo;
                }
            },
        },
        created() {
            if (this.values.authenticated) {
                this.currentStep = 2;
                this.getStatus();
                const vm = this;
                axios.get('/terms-of-service.html').then(r => {
                    vm.termsOfService = r.data;
                });
            }
        }
    }
</script>